import styled from 'styled-components'

import 'react-virtualized/styles.css'
import 'nprogress/nprogress.css'
export const Container = styled.div`
  display: flex;
  height: 100%;
  height: -webkit-fill-available;
  height: -moz-fill-available;
  flex-direction: column;
`
